if (!customElements.get('terms-acceptance')) {
  customElements.define(
    'terms-acceptance',
    class TermsAcceptance extends HTMLElement {
      constructor() {
        super();

        this.checkbox = this.querySelector('input[type="checkbox"]');
        this.inCartMessage = this.querySelector('.product__terms-in-cart');
        this.termsEnd = this.querySelector('.product__terms-end');
        this.scrollHint = this.querySelector('.product__terms-hint');
        this.termsRead = !this.termsEnd;

        this.checkbox.addEventListener('click', this.onCheckboxClick.bind(this));
      }

      cartUpdateUnsubscriber = undefined;

      connectedCallback() {
        const form = document.getElementById(this.dataset.formId);
        this.submitButton = form && form.querySelector('[type="submit"]');
        this.soldOut = this.submitButton ? this.submitButton.disabled : false;

        this.toggleLock(this.hasAttribute('data-in-cart'));
        this.updateScrollGate();
        if (!this.termsRead) this.watchTermsEnd();
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate.bind(this));
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.termsEndObserver) {
          this.termsEndObserver.disconnect();
        }
      }

      watchTermsEnd() {
        this.termsEndObserver = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.termsRead = true;
            this.termsEndObserver.disconnect();
            this.updateScrollGate();
          },
          { root: this.termsEnd.closest('.product__terms-content') }
        );
        this.termsEndObserver.observe(this.termsEnd);
      }

      onCheckboxClick(event) {
        if (this.termsRead) return;
        event.preventDefault();
        this.checkbox.reportValidity();
      }

      onCartUpdate(event) {
        if (event.source === 'product-form') {
          if (event.productVariantId === this.dataset.variantId) this.toggleLock(true);
          return;
        }

        const items = event.cartData && event.cartData.items;
        if (!items) return;
        this.toggleLock(items.some((item) => String(item.variant_id) === this.dataset.variantId));
      }

      updateScrollGate() {
        if (!this.scrollHint) return;

        const gated = !this.termsRead;
        this.scrollHint.hidden = !gated;
        this.checkbox.setAttribute('aria-disabled', gated);
        this.checkbox.setCustomValidity(gated ? this.scrollHint.textContent.trim() : '');
        if (gated) {
          this.checkbox.setAttribute('aria-describedby', this.scrollHint.id);
        } else {
          this.checkbox.removeAttribute('aria-describedby');
        }
      }

      toggleLock(locked) {
        this.checkbox.checked = false;
        this.checkbox.disabled = locked;
        this.inCartMessage.hidden = !locked;
        if (this.submitButton) this.submitButton.disabled = locked || this.soldOut;
      }
    }
  );
}
